import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, QueryList, ViewChildren } from '@angular/core';

@Component({
  selector: 'rr-tab-control',
  standalone: false,

  templateUrl: './tab-control.component.html',
  styleUrl: './tab-control.component.scss'
})
export class TabControlComponent implements AfterViewInit {
  @Input() activeStep: number = 1;
  steps: any[] = []
  tabs: NodeList | undefined;
  @ViewChildren('tabButton') tabButtons: any;

  constructor(private cdr: ChangeDetectorRef) { }

  setActiveTab(index: number) {
    this.activeStep = index;
    this.showActiceStepOnly();
  }
  ngAfterViewInit(): void {
    this.activeStep = parseInt(this.activeStep.toString());
    this.setActiveTab(this.activeStep);

    this.tabs = document.querySelectorAll('rr-tab');
    this.tabs.forEach((tab) => {
      const label = (tab as Element).getAttribute('label');
      const step = (tab as Element).getAttribute('step');
      this.steps.push({ label, index: parseInt(step || '1') })
    })
    this.steps.sort((a, b) => a.index - b.index);
    this.showActiceStepOnly();
    setTimeout(() => {
      this.setFocusOnActiveTab();
      this.cdr.detectChanges();
    }, 0);
  }
  private setFocusOnActiveTab() {
    setTimeout(() => {
      const activeButton = this.tabButtons.find((btn: any) => btn.nativeElement.classList.contains('active'));
      if (activeButton) {
        activeButton.nativeElement.focus();
      }
    });
  }
  showActiceStepOnly() {

    // console.log(this.buttons);
    // this.buttons?.forEach((button: any) => {
    //   button.blur();
    // });

    this.tabs?.forEach((tab) => {
      const step = (tab as Element).getAttribute('step') || '1';


      if (parseInt(step) == this.activeStep) {
        (tab as Element).classList.remove('hidden');
      } else {
        (tab as Element).classList.add('hidden')
      }
    })
  }
}
